import { render, staticRenderFns } from "./themePc.vue?vue&type=template&id=3accd8e8&scoped=true"
import script from "./themePc.vue?vue&type=script&lang=js"
export * from "./themePc.vue?vue&type=script&lang=js"
import style0 from "./themePc.vue?vue&type=style&index=0&id=3accd8e8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3accd8e8",
  null
  
)

export default component.exports